/* eslint-disable camelcase */
import request from '@/utils/request'

export function authDocument (p_query) {
  return request({
    url: '/documents/auth/' + p_query.document_id,
    method: 'get',
    params: p_query
  })
}

export function detailDocument (p_query, p_headers) {
  return request({
    headers: p_headers,
    url: '/documents/detail/' + p_query.document_id,
    method: 'get',
    params: p_query
  })
}

export function signDocument (p_document_id, p_data, p_headers) {
  return request({
    headers: p_headers,
    url: '/documents/' + p_document_id + '/employee/sign',
    method: 'put',
    data: p_data
  })
}



// WEBPACK FOOTER //
// ./src/api/document.js